import { Input } from "antd";
import styled from "styled-components";

import breakpoints from "@/constants/breakpoints";

export const InputSearch = styled(Input.Search)`
    max-width: 270px;

    @media ${breakpoints.lg} {
        max-width: 360px;
    }
`;
